// extracted by mini-css-extract-plugin
module.exports = {"Button":"MobileContextMenu_Button__7Mmez","Content":"MobileContextMenu_Content__S61Ph","Close":"MobileContextMenu_Close__4Y5_N","Backdrop":"MobileContextMenu_Backdrop__6_JIq"};